import { SupportTicketingComponent } from "../../components/support-ticketing-components";

export const SupportTicketing = () => {
  return <SupportTicketingComponent />;
};
